import { FormControlLabel, makeStyles, Switch } from "@material-ui/core";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateOnBoardingSettings } from "../../../../../../store/actions/creator/creatorOnBoarding";

const useStyles = makeStyles(() => ({
  root: {
    width: 230,
    zIndex: 10
  },
  container: {
    width: 230,
    zIndex: 1000,
    padding: '60px 8px 0 22px',
    height: '100%',
  },
  filterTitle: {
    fontFamily: 'roboto-bold',
    fontSize: 16,
    color: '#4F5F6E'
  },
  filterSubTitle: {
    fontFamily: 'roboto-bold',
    fontSize: '14px!important',
    color: '#697683',
    marginLeft: 10,
  },
  participantsPanel: {
    marginTop: 30,
    display: 'flex',
    flexDirection: 'column'
  },
  switchBtn: {
    marginLeft: -5
  },
  icon: {
    borderRadius: 3,
    width: 27,
    height: 28,
    backgroundColor: '#f5f8fa',
    backgroundImage: "url(\"/assets/icons/unchecked.svg\")",
    marginRight: 10
  },
  checkedIcon: {
    marginRight: 10,
    '&:before': {
      display: 'block',
      width: 31.5,
      height: 28,
      backgroundImage: "url(\"/assets/icons/checked.svg\")",
      content: '""',
    },
  },
  checkbox: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  switch: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  infoIcon: {
    width: 30,
    height: 30,
    cursor: 'pointer'
  },
  infoDiv: {
    width: 200,
    borderRadius: 20,
    backgroundColor: '#e4e4e4',
    padding: '15px 20px',
    fontSize: 14
  },
  infoTitle: {
    fontFamily: 'roboto-bold'
  },
  infoDescription: {
    marginTop: 4,
    fontFamily: 'roboto-regular'
  },
  btn: {
    height: 37,
    borderRadius: 6,
    background: '#0179EE',
    color: 'white',
    textTransform: 'none',
    fontSize: 14,
    fontFamily: 'roboto-regular',
    '&:hover': {
      background: '#0d77d4',
    },
  },
}));

export default function Module4Slide2FilterPanel(props: any) {
  const { header, onHandleToggle } = props;
  const classes = useStyles();
  const { module4Settings, userPreferences } = useSelector((state: any) => state.creatorOnBoarding);
  const { videoplayed, module4Data } = userPreferences;
  const { analyze } = module4Data.value;
  const { filterList } = module4Settings;
  const dispatch = useDispatch();

  const { participant_analyze, tags } = analyze;
  const [checkedList, setCheckedList] = useState<string[]>(filterList);

  const identifiers = participant_analyze
    .reduce((prev: any[], { }, index: number) => {
      const key = Object.keys(participant_analyze[index])[0] + "";
      const isValid = participant_analyze[index][key].immersion?.data;
      const tag = tags.find((item: any) => item.tag_id === key)
      isValid && prev.push(tag)
      return prev
    }, [])

  const getSwitchValue = (key: string) => {
    const check = checkedList.find((item: any) => item === key);
    return !!check;
  };

  const onHandleChange = (e: any) => {
    if (checkedList.includes(e.target.name)) {
      setCheckedList(checkedList.filter((item: any) => item !== e.target.name));
      dispatch(updateOnBoardingSettings('filterList', checkedList.filter((item: any) => item !== e.target.name)))
    } else {
      setCheckedList([...checkedList, e.target.name]);
      dispatch(updateOnBoardingSettings('filterList', [...checkedList, e.target.name]))
    }
    if (e.target.name !== 'All' && videoplayed.value) {
      onHandleToggle();
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.container} style={{paddingTop: header ? 10 : 60}}>
        {header}
        <>
          <div>
            <p className={classes.filterTitle}>Filters</p>
            <div className={classes.switch}>
              <FormControlLabel
                className={classes.switchBtn}
                classes={{
                  label: classes.filterSubTitle,
                }}
                control={
                  <Switch
                    checked={getSwitchValue('All')}
                    size="small"
                    onChange={onHandleChange}
                    name="All"
                    color="primary"
                  />
                }
                label="All Participants"
              />
            </div>
          </div>

          {identifiers.length > 0 && (
            <div className={classes.participantsPanel}>
              <p className={classes.filterTitle}>Tags</p>
              {identifiers.map((tag: any, index: number) => (
                <div className={classes.switch} key={index}>
                  <FormControlLabel
                    className={classes.switchBtn}
                    style={{ marginBottom: 8 }}
                    classes={{
                      label: classes.filterSubTitle
                    }}
                    control={
                      <Switch
                        checked={getSwitchValue(tag.tag_id)}
                        size="small"
                        onChange={onHandleChange}
                        name={tag.tag_id}
                        color="primary"
                      />
                    }
                    label={tag.tag_name}
                  />
                </div>
              ))
              }
            </div>
          )}
        </>
      </div>
    </div>
  )
}